/**
 * WordPress dependencies
 */
import { createBlobURL } from '@wordpress/blob';
import { createBlock } from '@wordpress/blocks';
const transforms = {
  from: [{
    type: 'files',

    isMatch(files) {
      return files.length === 1 && files[0].type.indexOf('audio/') === 0;
    },

    transform(files) {
      const file = files[0]; // We don't need to upload the media directly here
      // It's already done as part of the `componentDidMount`
      // in the audio block.

      const block = createBlock('core/audio', {
        src: createBlobURL(file)
      });
      return block;
    }

  }, {
    type: 'shortcode',
    tag: 'audio',
    attributes: {
      src: {
        type: 'string',
        shortcode: _ref => {
          let {
            named: {
              src,
              mp3,
              m4a,
              ogg,
              wav,
              wma
            }
          } = _ref;
          return src || mp3 || m4a || ogg || wav || wma;
        }
      },
      loop: {
        type: 'string',
        shortcode: _ref2 => {
          let {
            named: {
              loop
            }
          } = _ref2;
          return loop;
        }
      },
      autoplay: {
        type: 'string',
        shortcode: _ref3 => {
          let {
            named: {
              autoplay
            }
          } = _ref3;
          return autoplay;
        }
      },
      preload: {
        type: 'string',
        shortcode: _ref4 => {
          let {
            named: {
              preload
            }
          } = _ref4;
          return preload;
        }
      }
    }
  }]
};
export default transforms;
//# sourceMappingURL=transforms.js.map